<template>
  <v-card :loading="file.isLoading" style="max-width: 200px">
    <v-img
      :src="file.thumbnail"
      class="white--text align-end"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      height="200px"
    >
      <v-card-title class="caption" v-text="file.fileName"></v-card-title>
    </v-img>

    <v-card-actions style="max-height: 30px">
      <span>{{ size }}</span>
      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            color="primary"
            v-if="hasPreview && !file.isLoading"
            @click="preview(file)"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("View") }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="allowDelete"
            icon
            v-on="on"
            color="red"
            @click="remove(file)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("Delete") }}</span>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  props: {
    file: {
      type: Object,
    },
    size: {
      type: String,
    },
    allowDelete: {
      type: Boolean,
    },
    hasPreview: {
      type: Boolean,
    },
  },
  methods: {
    preview(file) {
      this.$emit("onPreview", file);
    },
    remove(file) {
      this.$emit("onRemove", file);
    },
  },
};
</script>